module.exports = __webpack_public_path__ + "img/member.d7883e94.svg";